module.exports = __webpack_public_path__ + "48571a65ffe8a316821fad251ed1d818.png";